import React from "react";
import { Link } from "gatsby";

import hasuraBrand from "./images/hasura-powered-logo.svg";
import discord from "./images/discord.svg";
import linkedin from "./images/linkedin.svg";
import twitter from "./images/twitter.svg";

const MobileFooter = () => (
  <div className="footerWrapper">
    <div className="desc">© Copyright 2020 Hasura</div>
    <div className="mobile-footer">
      <a href="/">
        <img src={hasuraBrand} alt="Hasura brand" />
      </a>
      <div className="socialIconWrapper">
        <a href="https://discord.com/invite/hasura" target="_blank" rel="noopener noreferrer">
          <img src={discord} alt="Discord" />
        </a>
        <a
          href="https://www.linkedin.com/company/hasura/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={linkedin} alt="Linkedin" />
        </a>
        <a href="https://twitter.com/hasurahq" target="_blank" rel="noopener noreferrer">
          <img src={twitter} alt="Twitter" />
        </a>
      </div>
    </div>
  </div>
);

const Footer = ({ bgColor, isMobile }) => {
  if (isMobile) {
    return <MobileFooter />;
  }

  let newDate = new Date();
  let year = newDate.getFullYear();

  return (
    <div className={"footerWrapper " + (bgColor ? bgColor : "")}>
      <div className="desc">© Copyright {year} Hasura</div>
    </div>
  );
};

export default Footer;
